import React, { useState } from "react";
import { styles } from "./Styles";
import {
  HomeIcon1,
  UserIcon,
  CincIcon,
  IssueIcon,
  GalleryIcon,
} from "../utils/constants/Icons.constants";
import { useLocation, useNavigate } from "react-router-dom";
import { RoutesPath } from "../routes/route-path";

const Sidebar = () => {
  const classes = styles;
  const router = useNavigate();
  const location = useLocation();

  const sideBarLinks = [
    {
      path: RoutesPath.HOME,
      icon: <HomeIcon1 styles={classes.icon} />,
    },
    {
      path: RoutesPath.REPORT_ISSUE,
      compare: RoutesPath.REPORT_ISSUE,
      icon: <IssueIcon styles={classes.icon} />,
    },
    {
      path: RoutesPath.USER,
      compare: RoutesPath.USER,
      icon: <UserIcon styles={classes.icon} />,
    },
    {
      path: RoutesPath.EVENT,
      compare: RoutesPath.EVENT,
      icon: <CincIcon styles={classes.icon} />,
    },

    {
      path: RoutesPath.GALLERY,
      compare: RoutesPath.GALLERY,
      icon: <GalleryIcon styles={classes.icon} />,
    },
  ];

  return (
    <div style={classes.sidebar}>
      <ul style={classes.ul}>
        {sideBarLinks.map((item, i) => (
          <li
            key={i}
            style={
              item.path === location.pathname ||
              location.pathname.includes(item.compare)
                ? classes.active
                : classes.inactive
            }
            onClick={() => router(item.path)}
          >
            {item.icon}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
